export default __webpack_public_path__ + "static/media/image_demo_benefits_summary.cb01f4b0.png";